import React from 'react';
import { StatusBadge, ExamStatus } from './StatusBadge';
import { ClockIcon, UserIcon } from 'lucide-react';
interface ExamCardProps {
  patientName: string;
  examType: string;
  time: string;
  doctor: string;
  status: ExamStatus | string;
  className?: string;
}
export function ExamCard({
  patientName,
  examType,
  time,
  doctor,
  status,
  className = ''
}: ExamCardProps) {
  return <div className={`medical-card p-4 min-w-[240px] md:min-w-[280px] flex flex-col gap-3 ${className}`} data-id="element-192">
      <div className="flex items-start justify-between gap-2" data-id="element-193">
        <div className="min-w-0" data-id="element-194">
          <h4 className="text-body font-semibold text-text-primary truncate" data-id="element-195">
            {patientName}
          </h4>
          <p className="text-small text-text-secondary truncate" data-id="element-196">{examType}</p>
        </div>
        <StatusBadge status={status} className="shrink-0" data-id="element-197" />
      </div>

      <div className="flex items-center justify-between text-small text-text-secondary mt-1 pt-3 border-t border-clinical-gray-100" data-id="element-198">
        <div className="flex items-center gap-1.5 shrink-0" data-id="element-199">
          <ClockIcon size={14} data-id="element-200" />
          <span data-id="element-201">{time}</span>
        </div>
        <div className="flex items-center gap-1.5 min-w-0" data-id="element-202">
          <UserIcon size={14} className="shrink-0" data-id="element-203" />
          <span className="truncate" data-id="element-204">{doctor}</span>
        </div>
      </div>
    </div>;
}